export const GET_BILLING_INVOICE_BEGIN = 'GET_BILLING_INVOICE_BEGIN'
export const GET_BILLING_INVOICE_SUCCESS = 'GET_BILLING_INVOICE_SUCCESS'
export const GET_BILLING_INVOICE_ERROR = 'GET_BILLING_INVOICE_ERROR'

export const POST_CREDIT_CARD_BEGIN = 'POST_CREDIT_CARD_BEGIN'
export const POST_CREDIT_CARD_SUCCESS = 'POST_CREDIT_CARD_SUCCESS'
export const POST_CREDIT_CARD_ERROR = 'POST_CREDIT_CARD_ERROR'

export const POST_BILLING_INVOICE_BEGIN = 'POST_BILLING_INVOICE_BEGIN'
export const POST_BILLING_INVOICE_SUCCESS = 'POST_BILLING_INVOICE_SUCCESS'
export const POST_BILLING_INVOICE_ERROR = 'POST_BILLING_INVOICE_ERROR'

export const POST_BILLING_PACKAGE_BEGIN = 'POST_BILLING_PACKAGE_BEGIN'
export const POST_BILLING_PACKAGE_SUCCESS = 'POST_BILLING_PACKAGE_SUCCESS'
export const POST_BILLING_PACKAGE_ERROR = 'POST_BILLING_PACKAGE_ERROR'

export const GET_NEWBILLING_COUNT_BEGIN = 'GET_NEWBILLING_COUNT_BEGIN'
export const GET_NEWBILLING_COUNT_SUCCESS = 'GET_NEWBILLING_COUNT_SUCCESS'
export const GET_NEWBILLING_COUNT_ERROR = 'GET_NEWBILLING_COUNT_ERROR'

export const CANCEL_PACKAGE_BEGIN = 'CANCEL_PACKAGE_BEGIN'
export const CANCEL_PACKAGE_SUCCESS = 'CANCEL_PACKAGE_SUCCESS'
export const CANCEL_PACKAGE_ERROR = 'CANCEL_PACKAGE_ERROR'

export const REACTIVATE_PACKAGE_BEGIN = 'REACTIVATE_PACKAGE_BEGIN'
export const REACTIVATE_PACKAGE_SUCCESS = 'REACTIVATE_PACKAGE_SUCCESS'
export const REACTIVATE_PACKAGE_ERROR = 'REACTIVATE_PACKAGE_ERROR'

export const TOGGLE_REACTIVATE_SUBSCRIPTION_POPUP = 'TOGGLE_REACTIVATE_SUBSCRIPTION_POPUP'

export const GET_BILLING_TYPE = 'GET_BILLING_TYPE'

export const REMOVE_PACKAGE_SUBSCRIPTION_BEGIN = 'REMOVE_PACKAGE_SUBSCRIPTION_BEGIN'
export const REMOVE_PACKAGE_SUBSCRIPTION_SUCCESS = 'REMOVE_PACKAGE_SUBSCRIPTION_SUCCESS'
export const REMOVE_PACKAGE_SUBSCRIPTION_ERROR = 'REMOVE_PACKAGE_SUBSCRIPTION_ERROR'

